import React, { useRef, useState, useEffect } from "react";
import {
  Info, Store, ShoppingCart, BookOpen, Briefcase, Layers, Activity,
  BarChart, FileText, Newspaper, PenTool, Users, Video, Rocket,
  Handshake, Download, MoreHorizontal, ImagePlus, Flame,
  PieChart, UsersRound, CalendarDays, Wrench, GraduationCap,
  ChevronLeft, ChevronRight, BadgePercent, HandCoins, Building2,
  Coins, HelpCircle, PlayCircle
} from "lucide-react";

/* ---------- MENU DATA (with small fixes) ---------- */
const menuItems = [

  // CONNECT
  {
    label: "Directory", icon: BookOpen, href: "/directory",
    submenu: [
      { label: "All Professionals", href: "/directory" },
      { label: "Browse by Role", href: "/directory" },
      { label: "Browse by Category", href: "/directory" },
      { label: "Explore Traders", href: "/directory" },
      { label: "Explore Investors", href: "/directory" }, // fixed path case
      { label: "Explore Brokers", href: "/directory" },
      { label: "Explore Mentors", href: "/directory" },
    ]
  },
  {
    label: "Community", icon: UsersRound, href: "/community",
    submenu: [
      { label: "Expert Room", href: "/community" },
      { label: "Live Experts", href: "/community" },
      { label: "Book Session", href: "/community" },
      { label: "Forum", href: "/community" },
      { label: "Members", href: "/community" },
      { label: "Trending", href: "/community" },
      { label: "Top Profiles", href: "/community" },
      { label: "Popular Trades", href: "/community" },
    ]
  },
  {
    label: "Market Office", icon: Store, href: "/dashboard",
    submenu: [
      { label: "My Office", href: "/dashboard" },
      { label: "My Network", href: "/dashboard" },
      { label: "My Profile", href: "/dashboard" },
      { label: "My Services", href: "/dashboard" },
      { label: "My Products", href: "/dashboard" },
      { label: "My Wallet", href: "/dashboard" },
      { label: "My Posts", href: "/dashboard" },
      { label: "My Appointments", href: "/dashboard" },
    ]
  },

  {
  label: "Market Tools", icon: Activity, href: "/dashboard/live-market",
  submenu: [
    { label: "Live Market", href: "/dashboard/live-market" },
    { label: "All Signals", href: "/dashboard/live-market" },
    { label: "Forex Signals", href: "/dashboard/live-market" },
    { label: "Crypto Signals", href: "/dashboard/live-market" },
    { label: "Technical Analysis", href: "/analysis/technical" },
    { label: "Reports", href: "/analysis/reports" },
    { label: "Screeners", href: "/tools/screeners" },
    { label: "Heatmaps", href: "/tools/heatmaps" },
    { label: "Economic Calendar", href: "/tools/calendar" },
    { label: "Alerts", href: "/tools/alerts" },
    { label: "Backtesting", href: "/tools/backtesting" },
    { label: "Library All", href: "/library" },
    { label: "E-Books", href: "/library/ebooks" },
    { label: "Whitepapers", href: "/library/whitepapers" },
    { label: "All News", href: "/news" },
    { label: "Market News", href: "/news/market" },
    { label: "Platform Updates", href: "/news/platform" },
  ]
},
  {
    label: "Marketplace", icon: ShoppingCart, href: "/marketplace",
    submenu: [
      { label: "All Products", href: "/marketplace/all" },
      { label: "Trending Products", href: "/marketplace/trending" },
      { label: "AI Market Tools", href: "/marketplace/tools" }, // was /trending
      { label: "Expert Advisors", href: "/marketplace/expertadvisors" },
      { label: "Today’s Offers", href: "/marketplace/offers" },
      { label: "Buy & Sell", href: "/marketplace/buy-sell" },
      { label: "List Your Products", href: "/marketplace/listyourproducts" },
      { label: "Product Reviews", href: "/marketplace/reviews" },
    ]
  },
  // WORK
  {
    label: "Jobs & Freelance", icon: Briefcase, href: "/jobs",
    submenu: [
      { label: "Job Board", href: "/jobs" },
      { label: "Post a Job", href: "/jobs/post" },
      { label: "Apply for Job", href: "/jobs/apply" },
      {
        label: "Freelance", // kept as group; renderer supports children
        children: [
          { label: "Apply", href: "/freelancing/apply" },
          { label: "Post Service", href: "/freelancing/post" },
        ]
      },
      { label: "Hire Professionals", href: "/services/hire" },
      { label: "Boost Your Search", href: "/jobs/boost" },
    ]
  },
  // SERVICES (flat)
  {
    label: "Services", icon: Layers, href: "/services",
    submenu: [
      { label: "All Services", href: "/services" },
      { label: "Top Services", href: "/services/top" },
      { label: "Hire Professionals", href: "/services/hire" },
      { label: "Trading Signals", href: "/services/signals" },
      { label: "Research & Reports", href: "/services/research" },
      { label: "Mentorship & Coaching", href: "/services/mentorship" },
      { label: "Portfolio Review", href: "/services/portfolio-review" },
      { label: "Brokerage & Liquidity Setup", href: "/services/brokerage" },
      { label: "Algo/Strategy Development", href: "/services/algo-dev" },
      { label: "API & Integrations", href: "/services/integrations" },
      { label: "Data Feeds & Market Tools", href: "/services/data" },
      { label: "Education & Courses", href: "/services/courses" },
      { label: "Webinars & Workshops", href: "/services/workshops" },
      { label: "Verification Services", href: "/services/verification" },
      { label: "Support & Tickets", href: "/services/support" },
      { label: "Request a Service", href: "/services/request" }
    ]
  },
  {
    label: "Schemes & Offers", icon: BadgePercent, href: "/schemes",
    submenu: [
      { label: "All Schemes", href: "/schemes" },
      { label: "Booster Packages (7/28 days)", href: "/schemes/boosters" },
      { label: "Referral Bonus", href: "/schemes/referral" },
      { label: "Seasonal Offers", href: "/schemes/seasonal" },
      { label: "New User Offers", href: "/schemes/new-user" },
      { label: "Partner Program", href: "/schemes/partners" }
    ]
  },

  // TOOLS (kept groups; renderer supports children)



  // 🔴 M2T STREAM (heart)
{
  label: "M2T Stream", icon: PlayCircle, href: "/stream",
  submenu: [
    { label: "All", href: "/stream" },
    { label: "Reels", href: "/stream/reels" },
    { label: "Videos", href: "/stream/videos" },
    { label: "Photos", href: "/stream/photos" },
    { label: "Articles", href: "/stream/articles" },
    { label: "Ads & Banners", href: "/stream/ads" },
    { label: "Top Traders", href: "/stream/top-traders" },
    { label: "Top Brokers", href: "/stream/top-brokers" },
    { label: "Analysis", href: "/stream/analysis" },
    { label: "Marketplace Picks", href: "/stream/marketplace" },
    { label: "Live Now", href: "/stream/live" },
  ]
},


  {
    label: "Media", icon: ImagePlus, href: "/media",
    submenu: [
      { label: "Photos", href: "/media/photos" },
      { label: "Videos", href: "/media/videos" },
      { label: "Trending Reels", href: "/media/reels" },
      { label: "M2T Stream", href: "/stream" },
      { label: "Live Now", href: "/stream/live" },
      { label: "Recorded", href: "/stream/recorded" },
      { label: "Blog", href: "/blog" },
      { label: "All Posts", href: "/blog" },
      { label: "Editor Picks", href: "/blog/featured" },
      { label: "Events", href: "/events" },
      { label: "Upcoming Events", href: "/events/upcoming" },
      { label: "Past Events", href: "/events/past" },
    ]
  },
  {
    label: "Launch", icon: Rocket, href: "/launchpad",
    submenu: [
      { label: "Launch Pad", href: "/launchpad" },
      { label: "New Projects", href: "/launchpad/new" },
      { label: "Submit Project", href: "/launchpad/submit" },
      { label: "Apply for Funding", href: "/launchpad/applyfunding" },
      { label: "Research tools", href: "/launchpad/researchtools" },
    ]
  },
  // CAPITAL
  {
    label: "Funding & Investments", icon: Coins, href: "/funding",
    submenu: [
      {
        label: "Funding",
        children: [
          { label: "Overview", href: "/funding" },
          { label: "Investor List", href: "/funding/investors" },
          { label: "Apply for Funds", href: "/funding/apply" },
          { label: "Deal Desk", href: "/dealdesk" },
          { label: "Deals", href: "/dealdesk/deals" },
          { label: "Post Deal", href: "/dealdesk/post" },
          { label: "Grants", href: "/funding/grants" },
        ]
      },
      {
        label: "Investments",
        children: [
          { label: "Mutual Funds", href: "/investments/mutual-funds" },
          { label: "SIP Plans", href: "/investments/sip" },
          { label: "Wealth Management", href: "/investments/wealth" },
          { label: "Portfolio Advisory", href: "/investments/advisory" },
          { label: "Tax-Saving Plans", href: "/investments/tax-saving" },
          { label: "Compare Plans", href: "/investments/compare" },
          { label: "Insurance Plans", href: "/investments/insurance" },
        ]
      },
    ]
  },
  {
    label: "Tax & Compliance", icon: FileText, href: "/compliance",
    submenu: [
      { label: "GST & Income Tax", href: "/compliance/tax" },
      { label: "KYC & Verification", href: "/compliance/kyc" },
      { label: "Licenses & Filings", href: "/compliance/filings" },
      { label: "Audit Support", href: "/compliance/audit" },
      { label: "Compliance (KYC/KYB)", href: "/services/compliance" },
      { label: "Legal & Contracts", href: "/services/legal" },
      { label: "Accounting & Tax", href: "/services/tax" },
    ]
  },
  {
    label: "Institutions", icon: Building2, href: "/institutions",
    submenu: [
      { label: "Banks & NBFCs", href: "/institutions/banks" },
      { label: "Broker Partners", href: "/institutions/brokers" },
      { label: "Fintech Firms", href: "/institutions/fintech" },
      { label: "Government Links", href: "/institutions/gov" },
    ]
  },
  {
    label: "Academy", icon: GraduationCap, href: "/academy",
    submenu: [
      { label: "Courses", href: "/academy/courses" },
      { label: "Certifications", href: "/academy/certifications" },
      { label: "Webinars & Workshops", href: "/services/workshops" },
      { label: "Create Courses", href: "/academy/createcourses" },
      { label: "Trading Institutions", href: "/academy/tradinginstitutions" },
      { label: "Top Market Schools", href: "/academy/topmarketschools" },
      { label: "Learn Markets", href: "/academy/learnmarkets" },
    ]
  },
  {
    label: "Resources", icon: Download, href: "/download",
    submenu: [
      { label: "Download", href: "/download" },
      { label: "Mobile App", href: "/download/app" },
      { label: "Browser Extension", href: "/download/extension" },
    ]
  },
  {
    label: "More", icon: MoreHorizontal, href: "/more",
    submenu: [
      { label: "Partners", href: "/more/partners" },
      { label: "Policies", href: "/more/policies" },
      { label: "FAQs", href: "/more/faqs" },
      { label: "Help Center", href: "/more/help" }
    ]
  }
];

/* ---------- COMPONENT ---------- */
export default function SubHeader() {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (!scrollRef.current) return;
      const el = scrollRef.current;
      setShowArrows(el.scrollWidth > el.clientWidth);
    };
    const t = setTimeout(checkOverflow, 100);
    const obs = new ResizeObserver(checkOverflow);
    if (scrollRef.current) obs.observe(scrollRef.current);
    window.addEventListener("resize", checkOverflow);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", checkOverflow);
      obs.disconnect();
    };
  }, []);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const { scrollLeft, clientWidth } = scrollRef.current;
    scrollRef.current.scrollTo({
      left: dir === "left" ? scrollLeft - clientWidth : scrollLeft + clientWidth,
      behavior: "smooth",
    });
  };

  /* Recursive renderer: supports items with `children` or plain links */
  const renderSubmenu = (items) => (
    <div className="grid grid-cols-1 gap-2 w-max">
      {items.map((item, i) => {
        const hasChildren = Array.isArray(item.children) && item.children.length > 0;
        if (hasChildren) {
          return (
            <div key={`grp-${item.label}-${i}`} className="py-1">
              <div className="text-[11px] uppercase text-gray-300 font-semibold tracking-wide mb-1">
                {item.label}
              </div>
              {renderSubmenu(item.children)}
            </div>
          );
        }
        return (
          <a
            key={`lnk-${item.href || item.label}-${i}`}
            href={item.href || "#"}
            className="text-sm hover:text-yellow-500 whitespace-nowrap"
          >
            {item.label}
          </a>
        );
      })}
    </div>
  );

  return (
    <div className="relative">
      {showArrows && (
        <>
          <div className="absolute left-0 top-1/2 -translate-y-1/2 z-[9999]">
            <button onClick={() => scroll("left")} className="p-2 bg-black/50 hover:bg-black rounded-full">
              <ChevronLeft size={18} />
            </button>
          </div>
          <div className="absolute right-0 top-1/2 -translate-y-1/2 z-[9999]">
            <button onClick={() => scroll("right")} className="p-2 bg-black/50 hover:bg-black rounded-full">
              <ChevronRight size={18} />
            </button>
          </div>
        </>
      )}

      <div className="relative overflow-x-auto no-scrollbar px-12 py-3" ref={scrollRef}>
        <div className="border border-gray-900 rounded-lg flex gap-0 p-2 min-w-max justify-center">
          {menuItems.map(({ href, label, icon: Icon, submenu }, index) => (
            <div
              key={href}
              className="relative px-2"
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <div className="flex flex-col items-center justify-center group">
                <a href={href} className="flex flex-col items-center justify-center focus:outline-none">
                  <Icon size={18} className="mb-[6px]" />
                  <span className="text-[10px] max-w-[60px] text-center">
                    {label}{submenu && <span className="ml-1 text-[8px]">▾</span>}
                  </span>
                </a>
              </div>

              {submenu && activeIndex === index && (
                <div
                  className="fixed z-[9999] mt-2 -translate-x-1/2 bg-neutral-600/95 text-white p-3
                             border border-gray-900 rounded-lg shadow-lg overflow-visible"
                  style={{ top: 135 }}
                >
                  {renderSubmenu(submenu)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
